module.exports = __webpack_public_path__ + "img/non-returnable-medium.fcfbb9d.svg";